<template>
  <div class="h-100 w-100">
    <div class="container-content">
      <div class="overlay-bg">
        <div class="header-logo">
          <img src="@/assets/images/rammsv2.png" style="width: 130px" alt="..." />
        </div>
        <div class="content-body">
          <div class="justify-content-center" :class="!isLive ? 'd-flex' : 'd-block align-items-center'">
            <div class="row justify-content-center m-0 pt-3" style="z-index: 9999" :class="{
              'd-none': !isLive,
              'd-flex': isLive,
            }">
              <div class="col-md-6">
                <div class="card">
                  <div class="container-vid bg-dark">
                    <video controls id="videoElement" class="w-100" muted
                      :class="{ 'd-none': !isLive, 'd-block': isLive }">
                      <source id="mp4" type="video/mp4" />
                    </video>
                    <div class="card-is-offline" v-if="!isLive">
                      <a class="h-100">
                        <img class="h-100 w-auto" src="https://via.placeholder.com/728x409.png?text=OFFLINE"
                          alt="..." />
                      </a>
                    </div>
                  </div>
                  <div class="card-is-live-desc">
                    <div class="rounded-circle bg-danger d-block"
                      style="height: 10px; width: 10px; margin-right: 0.5rem"></div>
                    <p class="m-0">Live Streaming</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-wrap justify-content-center m-0" style="z-index: 10">
              <div style="width: 180px" class="me-2">
                <div class="card card-parent" :class="{ 'is-open': openCard === 'rad' }">
                  <div class="group-list">
                    <div class="group-item d-flex justify-content-between">
                      <div class="main-menu p-2 w-50">
                        <div class="d-flex text-white mb-2"
                          @click="siteClicked('https://roadassetjkr.selangor.gov.my/#/login')">
                          <img style="width: 60px" src="@/assets/images/infrasel_2.png" alt="..." />
                          <p class="mb-0 small ml-2">
                            <br>
                            VBMMS
                          </p>
                        </div>
                        <div class="d-flex text-white"
                          @click="siteClicked('https://geospatial.selgem.com/portal/apps/webappviewer/index.html?id=23c63b740bcb46bb8abcfd2a3ce67a8c')">
                          <img style="width: 60px" src="@/assets/images/infrasel_8.png" alt="..." />
                          <p class="mb-0 small ml-2">
                            Road Side <br>
                            Development
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column" @click="toggleCard('rad')">
                    <div class="position-absolute bg-white rounded" style="bottom: 0; width: 100%; height: 100px"></div>
                    <div style="height: auto; width: 100%">
                      <img @mouseenter="transformbg = `-50px`" @mouseleave="transformbg = '-20px'" class="h-100 w-100"
                        src="@/assets/images/infrasel_2.png" alt="..." />
                    </div>
                    <div style="z-index: 100">
                      <p class="card-text text-center">
                        Road Asset <br />
                        Digitalisation
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 180px" class="me-2">
                <div class="card" @click="siteClicked('https://rondajkr.selangor.gov.my')">
                  <div class="d-flex flex-column">
                    <div class="position-absolute bg-white rounded" style="bottom: 0; width: 100%; height: 100px"></div>
                    <div style="height: auto; width: 100%">
                      <img @mouseenter="transformbg = `-50px`" @mouseleave="transformbg = '-20px'" class="h-100 w-100"
                        src="@/assets/images/infrasel_1.png" alt="..." />
                    </div>
                    <div style="z-index: 100">
                      <p class="card-text text-center">
                        RONDA <br />
                        &nbsp;
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 180px" class="is-mobile me-2">
                <div class="card" @click="siteClicked('https://cms-nod.infrasel.co')">
                  <div class="d-flex flex-column">
                    <div class="position-absolute bg-white rounded" style="bottom: 0; width: 100%; height: 100px"></div>
                    <div style="height: auto; width: 100%">
                      <img @mouseenter="transformbg = `-50px`" @mouseleave="transformbg = '-20px'" class="h-100 w-100"
                        src="@/assets/images/infrasel_3.png" alt="..." />
                    </div>
                    <div style="z-index: 100">
                      <p class="card-text text-center">
                        Contract Management <br />
                        System (AK)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 180px" class="is-mobile me-2">
                <div class="card">
                  <div class="card" @click="siteClicked('http://cms.infrasel.co')">
                    <div class="d-flex flex-column">
                      <div class="position-absolute bg-white rounded" style="bottom: 0; width: 100%; height: 100px">
                      </div>
                      <div style="height: auto; width: 100%">
                        <img @mouseenter="transformbg = `-50px`" @mouseleave="transformbg = '-20px'" class="h-100 w-100"
                          src="@/assets/images/infrasel_6.png" alt="..." />
                      </div>
                      <div style="z-index: 100">
                        <p class="card-text text-center">
                          Contract Management <br />
                          System (Routine)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 180px" class="is-desktop me-2">
                <div class="card card-parent" :class="{ 'is-open': openCard === 'rmcs' }">
                  <div class="group-list">
                    <div class="group-item d-flex justify-content-between">
                      <div class="main-menu p-2 w-50">
                        <div class="d-flex text-white" @click="openChild('cms')">
                          <img style="width: 60px" src="@/assets/images/infrasel_4.png" alt="..." />
                          <p class="mb-0 small ml-2">
                            Contract Management System
                          </p>
                        </div>
                      </div>
                      <div class="w-50">
                        <div class="ms-3 child-item ps-2 w-100 border-start border-2" id="cms">
                          <div class="d-flex align-items-center text-white"
                            @click="siteClicked('https://cmsnodjkr.selangor.gov.my')">
                            <img style="width: 40px" src="@/assets/images/infrasel_3.png" alt="..." />
                            <p class="mb-0 small ml-2">AK</p>
                          </div>
                          <div class="d-flex align-items-center text-white"
                            @click="siteClicked('https://cmsjkr.selangor.gov.my')">
                            <img style="width: 40px" src="@/assets/images/infrasel_6.png" alt="..." />
                            <p class="mb-0 small ml-2">Routine</p>
                          </div>
                          <div class="d-flex align-items-center text-white"
                            @click="siteClicked('https://procjkr.selangor.gov.my')">
                            <img style="width: 40px" src="@/assets/images/infrasel_5.png" alt="..." />
                            <p class="mb-0 small ml-2">Sebut Harga</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column" @click="toggleCard('rmcs')">
                    <div class="position-absolute bg-white rounded" style="bottom: 0; width: 100%; height: 100px"></div>
                    <div style="height: auto; width: 100%">
                      <img @mouseenter="transformbg = `-50px`" @mouseleave="transformbg = '-20px'" class="h-100 w-100"
                        src="@/assets/images/infrasel_4.png" alt="..." />
                    </div>
                    <div style="z-index: 100">
                      <p class="card-text text-center">
                        RMCS <br />
                        &nbsp;
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 180px" class="me-2">
                <div class="card" @click="
                  siteClicked('http://selangortrams.ipaves.my/site/login')
                  ">
                  <div class="d-flex flex-column">
                    <div class="position-absolute bg-white rounded" style="bottom: 0; width: 100%; height: 100px"></div>
                    <div style="height: auto; width: 100%">
                      <img @mouseenter="transformbg = `-50px`" @mouseleave="transformbg = '-20px'" class="h-100 w-100"
                        src="@/assets/images/infrasel_7.png" alt="..." />
                    </div>
                    <div style="z-index: 100">
                      <p class="card-text text-center">
                        SPAJA <br />
                        &nbsp;
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      transformbg: "-20px",
      isLive: false,
      openCard: null,
    };
  },
  methods: {
    siteClicked(url) {
      window.open(url);
    },
    toggleCard(id) {
      this.openCard = this.openCard === id ? null : id;
    },
    openChild(id) {
      // Hover shows the children via CSS; click pins them open. Never add
      // d-none here: its !important would block the hover rule.
      document.getElementById(id).classList.toggle("d-block");
    },
    loadVideo() {
      if (flvjs.isSupported()) {
        var videoElement = document.getElementById("videoElement");

        if (typeof this.flvPlayer !== "undefined") {
          if (this.flvPlayer != null) {
            this.flvPlayer.unload();
            this.flvPlayer.detachMediaElement();
            this.flvPlayer.destroy();
            this.flvPlayer = null;
          }
        }
        var mp4 = document.getElementById("mp4");
        mp4.src = null;
        this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          url: "https://playback.inference.asia/live/cc.flv",
          hasAudio: false,
          enableStashBuffer: false,
        });
        this.flvPlayer.attachMediaElement(videoElement);
        this.flvPlayer.load();
        this.flvPlayer.play();
      }
    },
  },
  mounted() {
    flvjs.LoggingControl.addLogListener((type, str) => {
      if (str.includes("onSourceEnded")) {
        this.isLive = false;
        this.loadVideo();
      }

      if (str.includes("Received Initialization")) {
        if (typeof this.flvPlayer !== "undefined" && this.flvPlayer != null) {
          this.isLive = true;
          this.flvPlayer.play();
        }
      }
    });
    this.loadVideo();
  },
};
</script>
